
import { onBeforeUpdate, onMounted, onUpdated, reactive, ref, watch } from "vue";
import { Options, setup, Vue } from 'vue-class-component';

@Options({})
export default class ZhTabSet extends Vue {

  tabInfo = setup(() => {
    let slots: any = this.$slots;

    const defaults = reactive<any[]>([]);
    const titles = reactive<any[]>([]);
    const currentIndex = ref(0);
    const activeLineWidth = ref(0);
    const activeLineTransformWidth = ref(0);
    let tabTitleRefs: any = [];
    let tabTitleWidthArr: any[] = [];
    onBeforeUpdate(() => {
      tabTitleRefs = [];
    })
    onUpdated(() => {
      calcCurrentTabInfo();
      console.log("onUpdated");
    })

    onMounted(() => {
      getItemsAndTitlesFromSlots();
      calcCurrentTabInfo();
    })

    watch(slots.default, (cur, prev) => {
      getItemsAndTitlesFromSlots();
      currentIndex.value = 0;
      calcCurrentTabInfo();
    })

    const getItemsAndTitlesFromSlots = () => {
      const def = slots.default;
      let items: any[] = [];
      if (def != undefined) {
        items = def();
      }
      items = items.filter(tag => {
        return tag.children !== "v-if"
      })
      defaults.splice(0, defaults.length, ...items);
      console.log(defaults);

      const titleList = items.map((tag, index) => {
        console.log(tag,"tag.props------------------");
        
        return (tag.props == null || tag.props.title === undefined) ? ("标题" + (index + 1)) : tag.props.title
      });
      titles.splice(0, titles.length, ...titleList);
      console.log(titleList);
    }
    const calcCurrentTabInfo = () => {
      calcTabTitleWidth();
      calcTabActiveLineWidth();
      calcTabActiveLineActiveLineTransformWidth();
    }
    const calcTabTitleWidth = () => {
      tabTitleWidthArr = tabTitleRefs.map((dom: any) => {
        return dom.offsetWidth;
      })
    }
    const calcTabActiveLineWidth = () => {
      activeLineWidth.value = tabTitleWidthArr[currentIndex.value];
    }
    const calcTabActiveLineActiveLineTransformWidth = () => {
      let tmp = 0;
      for (let i = 0; i < currentIndex.value; i++) {
        tmp += tabTitleWidthArr[i];
        tmp += 10;
      }
      activeLineTransformWidth.value = tmp;
    }


    const setTabTitleRefs = (el: any) => {
      tabTitleRefs.push(el);
    }
    return {defaults, titles, currentIndex, activeLineWidth, activeLineTransformWidth, setTabTitleRefs};
  })
}

